import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppBootSplash } from "@/components/layout/AppLoading";
import { selectAuthStatus } from "@/features/auth/authSlice";

/**
 * Holds the route until the session is resolved. The old app rendered protected
 * routes off a decrypted localStorage user, so a stale cached profile could
 * paint a page the server would then reject.
 */
export function RequireAuth() {
  const status = useSelector(selectAuthStatus);
  const location = useLocation();

  if (status === "loading") {
    return <AppBootSplash />;
  }

  if (status === "authenticated") {
    return <Outlet />;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
}
